var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},[_c('el-switch',{attrs:{"active-text":_vm.currentField.activeText,"inactive-text":_vm.currentField.inActiveText},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }